import actionTypes from "constants/bgTasks";
import { BG_TASK_TYPES } from "helpers/bgTasks";
import { workloadStatusesEnum } from "helpers/enums";
import { REPORT_TYPES } from "helpers/reportTypes";
import { Action, handleActions } from "redux-actions";

const { ADD, UPDATE, REMOVE, REMOVE_ALL } = actionTypes;

const initialState: State = { items: {} };

type BgTaskModel = {
    key: string;
    startDate: string;
    endDate: string;
    title: string;
    status: keyof typeof workloadStatusesEnum;
    reportType: keyof typeof REPORT_TYPES;
    taskType: keyof typeof BG_TASK_TYPES;
    fileName?: string;
};

type State = { items: { [key: string]: BgTaskModel } };
type AddPayload = { key: string; data: BgTaskModel };
type RemovePayload = { key: string };

type CombinedPayloads = AddPayload | RemovePayload;

export default handleActions<State, CombinedPayloads>(
    {
        [ADD]: (state, { payload }: Action<AddPayload>) => {
            return { items: { ...state.items, [payload.key]: payload.data } };
        },
        [UPDATE]: (state, { payload }: Action<AddPayload>) => {
            if (!state.items[payload.key]) {
                return { items: { ...state.items } };
            }
            return { items: { ...state.items, [payload.key]: { ...state.items[payload.key], ...payload.data } } };
        },
        [REMOVE]: (state, { payload }: Action<RemovePayload>) => {
            const { items } = state;
            delete items[payload.key];
            return { items };
        },
        [REMOVE_ALL]: () => ({
            items: {},
        }),
    },
    initialState,
);
